const de = {
  approve: 'Freischalten',
  details: 'Detailansicht',
  companyDetails: 'Firmendaten',
  invoiceAddress: 'Rechnungsadresse',
  company: 'Unternehmen',
  invoice: 'Rechnung',
  faculties: 'Fakultäten',
  jobManagement: 'Stellenverwaltung',
  cancelConfirm: {
    message: 'Sie haben Änderungen vorgenommen. Wollen Sie sie wirklich verwerfen?',
    title: 'Wirklich abbrechen?'
  },
  rejectConfirm: {
    message: 'Wollen Sie wirklich diese Firma ablehnen? Die Firma wird hierbei gelöscht!',
    title: 'Wirklich ablehnen?'
  },
  deleteConfirm: {
    message: 'Wollen Sie wirklich diese Firma löschen?',
    title: 'Wirklich löschen?'
  },
  alerts: {
    saveSuccessful: 'Die Firmendaten wurden erfolgreich aktualisiert.',
    saveFailed: 'Die Firmendaten konnten nicht aktualisiert werden.',
    changeStateSuccessful: 'Der Firmenstatus wurde erfolgreich aktualisiert.',
    changeStateFailed: 'Der Firmenstatus konnte nicht aktualisiert werden.',
    deleteSuccessful: 'Die Firma wurde erfolgreich gelöscht.',
    deleteFailed: 'Die Firma konnte nicht gelöscht werden.'
  },
  logoUploadPlaceholder: 'Logo hochladen (Optimales Seitenverhältnis 5:3)',
  companyName: 'Firmenname',
  registerDate: 'Registrierungsdatum',
  activeCompanies: 'Aktive Firmen',
  inactiveCompanies: 'Inaktive Firmen',
  archivedCompanies: 'Archivierte Firmen',
  bannedCompanies: 'Gebannte Firmen',
  companyProfile: 'Firmenprofil',
  unbanCompany: {
    title: '{{name}} entsperren',
    message:
      'Wollen Sie die Firma wirklich entsperren? Sie wurde aus den folgenden Gründen gesperrt:'
  },
  createCompany: 'Firma erstellen',
  agreeToNewsletter: 'Hiermit stimme ich der Zusendung des Stellenmarkt-Newsletters zu.'
};
export default de;
export type ManageCompaniesTranslation = typeof de;
